class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.isLoadingAll = false;

    // ✅ Stop everything if there's only 1 page
    const pageCount = parseInt(this.dataset.pageCount || '1');
    this.isLastPage = pageCount <= 1;

    if (this.isLastPage) {
      const button = this.querySelector('.load-more-button');
      if (button) button.style.display = 'none'; // Hide button if not needed
      return; // ⛔ Do not set up listeners
    }

    // Initialize scroll-based loading
    this.loadMoreOnScroll();

    // Listen for full filtered load
    document.addEventListener('load-all-filtered-results', () => {
      this.loadAllFilteredResults();
    });
  }

  loadMoreOnScroll() {
    const button = this.querySelector('.load-more-button');
    window.addEventListener('scroll', () => {
      if (this.isLoadingAll || this.isLastPage) return;

      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 2500;
      if (nearBottom) {
        if (!button.classList.contains('loading')) {
          button.classList.add('loading');
          setTimeout(() => {
            this.loadData(false); // false = don't clear grid
          }, 1000);
        }
      }
    });
  }

  loadData(clearGrid = false) {
    if (this.isLastPage) return;

    const button = this.querySelector('.load-more-button');
    const collectionModel = document.querySelector('.product-grid');
    const newUrl = this.getAttribute('page-url');

    if (!newUrl) {
      this.isLastPage = true;
      button.style.display = 'none';
      return;
    }

    return fetch(newUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const newItems = responseHTML.querySelectorAll('.product-grid .grid__item');
        const nextUrl = responseHTML.querySelector('load-more')?.getAttribute('page-url') || '';

        if (newItems.length) {
          if (clearGrid) {
            collectionModel.innerHTML = '';
          }
          newItems.forEach((item) => {
            collectionModel.appendChild(item);
          });

          this.setAttribute('page-url', nextUrl);
          document.dispatchEvent(new Event('collection:updated'));
        }

        button.classList.remove('loading');

        if (!nextUrl) {
          this.isLastPage = true;
          button.style.display = 'none';
        }

        return nextUrl;
      })
      .catch((error) => {
        console.error('Error fetching collection data:', error);
        button.classList.remove('loading');
        throw error;
      });
  }

  async loadAllFilteredResults() {
    this.isLoadingAll = true;
    const button = this.querySelector('.load-more-button');
    button.classList.add('loading');

    try {
      let isFirstLoad = true;
      while (!this.isLastPage) {
        const nextUrl = await this.loadData(isFirstLoad);
        isFirstLoad = false;

        if (!nextUrl) {
          this.isLastPage = true;
          button.style.display = 'none';
          break;
        }

        await new Promise((resolve) => setTimeout(resolve, 500));
      }
    } catch (error) {
      console.error('Error loading all filtered results:', error);
    } finally {
      button.classList.remove('loading');
      this.isLoadingAll = false;
    }
  }
}

customElements.define('load-more', LoadMore);
